module.exports = __webpack_public_path__ + "images/category_lp/watch/case1_f32d48bee4cf7332bdb8603f26d3bb4f.jpg";